"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicCard = void 0;
const react_1 = __importDefault(require("react"));
require("./TopicCard.scss");
const style = __importStar(require("./TopicCard.scss.json"));
const package_1 = require("../../package");
const Topic_1 = require("../../shapes/Topic");
const VCard_1 = __importDefault(require("../atoms/VCard"));
const react_2 = require("@tolgee/react");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
exports.TopicCard = (0, package_1.linkedComponent)(Topic_1.Topic.request((topic) => {
    var _a;
    return {
        name: topic.name,
        id: topic.identifier,
        description: topic.description,
        image: (_a = topic === null || topic === void 0 ? void 0 : topic.image) === null || _a === void 0 ? void 0 : _a.contentUrl,
    };
}), (_a) => {
    var { linkedData, cardTitle, overlay } = _a, props = __rest(_a, ["linkedData", "cardTitle", "overlay"]);
    let { id, name, description, image } = linkedData;
    //create the translation function, use the common namespace
    let { t } = (0, react_2.useTranslate)();
    //with t(key,defaultValue) the key will show up on in the dev context app (hover text and hold Option) and can be added and translated in tolgee.
    let prefix = 'topic' + id;
    return (react_1.default.createElement("div", { className: style.Root },
        react_1.default.createElement(VCard_1.default, Object.assign({}, props, { 
            // Todo: change 'action' => prop cardTitle and pass the card title from the parent component
            title: t('topic-card.title', cardTitle ? cardTitle : 'Topic' + id && id), classNames: style.topicCard, subTitle: t(`${prefix}.name`, name), image: (0, LinkedFileStorage_1.asset)(image), imageDescription: t(`${prefix}.description`, description), description: t(`${prefix}.description`, description) })),
        overlay ? overlay : null));
});
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=TopicCard.js.map